import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { de, el } from 'date-fns/locale';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { environment } from 'src/app/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EntrypointcolorService {
  apiBaseUrl = environment.baseApiUrl;
  entryPointColors: any = [];

  private readonly fasTotalLabel = 'FAS Total';
  private readonly fasSegmentLabels = [
    'FAS - Broker/Dealers',
    'FAS - RIAs',
    'FAS - Bank',
  ];

  constructor(private http: HttpClient) {
    this.getEntrypointColorPalette;
  }

  // Call the service to get the color palette
  // this.subscriptionEntryPointColor = this.crossTabService
  //   .getOrFetchEntrypointColorPalette(this.selected_client)
  //   .subscribe({
  //     next: (response) => {
  //       this.entryPointColors = response;
  //       this.crossTabService.setEntrypointColorPalette(response);
  //     },
  //     error: (err) => {
  //       console.error('Error fetching entrypoint color palette:', err); // Handle errors
  //     },
  //   });

  // Store the Audience color palette in a BehaviorSubject
  private audienceColorPaletteSubject = new BehaviorSubject<any>([]);
  audienceColorPalette$ = this.audienceColorPaletteSubject.asObservable();

  //=============== Audience color change ================
  // Function to get the color palette based on client name
  getEntrypointColorPalette(clientCode: string): Observable<string[]> {
    const body = { clientCode }; // Input object for the request

    return this.http.post<any>(
      `${this.apiBaseUrl}api/CrosstabOutput/getEntrypointColorPalette`,
      body,
    );
  }

  // Function to get or fetch the color palette based on client name
  getOrFetchEntrypointColorPalette(clientCode: string): Observable<string[]> {
    // Check if color palette data is already available
    if (
      this.audienceColorPaletteSubject.value &&
      this.audienceColorPaletteSubject.value.length > 0
    ) {
      // Return the existing data as an observable
      this.entryPointColors = this.audienceColorPaletteSubject.value;
      return of(this.audienceColorPaletteSubject.value);
    } else {
      // If data is not present, fetch it from the API
      return this.getEntrypointColorPalette(clientCode).pipe(
        tap((colorPalette: any) => {
          this.setEntrypointColorPalette(colorPalette); // Update BehaviorSubject with fetched data
        }),
      );
    }
  }

  // Set the color palette data in the BehaviorSubject
  setEntrypointColorPalette(colorPalette: string[]) {
    this.entryPointColors = colorPalette;
    this.audienceColorPaletteSubject.next(colorPalette); // Update the BehaviorSubject with new color palette
  }

  //For Entrypoint checking and highlighting in selection summary(Audience)
  checkForEntryPoint(mainKey: string): boolean {
    // Implement your logic to check for entry point here
    if (
      mainKey.toLowerCase() == 'audience' ||
      mainKey.toLowerCase() == 'column nesting'
    )
      return true;
    else return false;
  }

  getEntryPointHighlightColor(): string {
    return '';
    //return 'yellow';
  }

  getHighlightColor(key: string, val: string): string {
    //console.log('Value for color coding:', this.entryPointColors);
    if (key.toLowerCase() == 'column nesting') {
      val = val.replace('Audience:', '');
    }
    val = val.trim();
    // console.log(this.entryPointColors);
    let brandVal = this.entryPointColors.find(
      (entry: any) => entry.brandName.toLowerCase() == val.toLowerCase(),
    );

    if (brandVal != undefined) {
      return brandVal.hexCode;
    }

    // FAS Total is synthetic — use the same green as FAS audience segments
    if (val.toLowerCase() === this.fasTotalLabel.toLowerCase()) {
      for (const segment of this.fasSegmentLabels) {
        const segmentColor = this.entryPointColors.find(
          (entry: any) =>
            entry.brandName?.toLowerCase() === segment.toLowerCase(),
        );
        if (segmentColor?.hexCode) {
          return segmentColor.hexCode;
        }
      }
    }

    return '';
  }

  getSnapshotHighlightColorForSummary(key: string, val: string): string {
    let coloArr = [];
    if (this.checkForEntryPoint(key)) {
      let valArr = val.split(',');
      for (let i = 0; i < valArr.length; i++) {
        const trimmed = (valArr[i] || '').trim();
        if (!trimmed) {
          continue;
        }
        let color = this.getHighlightColor(key, trimmed);
        if (color) {
          coloArr.push(
            '<span style="background-color: ' +
              color +
              '; padding: 0.1rem;">' +
              trimmed +
              '</span>',
          );
        } else {
          // Keep label visible even when no palette color is configured
          coloArr.push(trimmed);
        }
      }
      return coloArr.join(', ');
    } else {
      return val;
    }
  }

  getColorForSummary(dataVal: any) {
    //debugger;
    //return this.getSnapshotHighlightColorForSummary('Column Nesting', val);
    let coloArr = [];
    for (let j = 0; j < dataVal.length; j++) {
      let valArr = dataVal[j].split(',');
      //console.log('Key for color coding:', dataVal[j]);
      for (let i = 0; i < valArr.length; i++) {
        // console.log('Value for color coding:', this.entryPointColors);
        let Audiencetext = '';
        if (valArr[i].includes('Audience:')) {
          valArr[i] = valArr[i].replace('Audience:', '');
          Audiencetext = '<span>Audience: </span>';
        }
        let color = this.getHighlightColor('', valArr[i]);
        if (color) {
          coloArr.push(
            Audiencetext +
              '<span style="background-color: ' +
              color +
              '; padding: 0.1rem;">' +
              valArr[i] +
              '</span>',
          );
        } else {
          coloArr.push(Audiencetext + '<span>' + valArr[i] + '</span>');
        }
      }
    }
    return coloArr.join(', ');
  }
}
